import type { SnackbarCloseReason } from '@mui/material/Snackbar'

/** Default auto-dismiss when the user does not close the toast manually. */
export const APP_TOAST_AUTO_HIDE_MS = 5000

/** Only the auto-hide timer may dismiss via Snackbar `onClose` — not click-away or Escape. */
export function shouldDismissAppToastOnSnackbarClose(reason: SnackbarCloseReason): boolean {
  return reason === 'timeout'
}

/** Figma handoff — upper-right corner (16px from viewport edges). */
export const APP_TOAST_SNACKBAR_ANCHOR = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
}

/** Override MUI Snackbar default top/right (24px) so the toast sits flush in the corner. */
export const APP_TOAST_SNACKBAR_SX = {
  top: '16px !important',
  right: '16px !important',
  left: 'auto !important',
  bottom: 'auto !important',
  zIndex: 1400,
}
